import type { Components, Theme } from "@mui/material/styles";
import { operational } from "@mideye/design-tokens";
import { darkColors, lightColors } from "../tokens/colors.ts";

export function getMuiChip(mode: "dark" | "light"): Components<Theme>["MuiChip"] {
  const c = mode === "dark" ? darkColors : lightColors;
  return {
    styleOverrides: {
      root: {
        fontWeight: 600,
        borderRadius: "0.375rem",
      },
      colorError: {
        backgroundColor: c.errorContainer,
        color: c.onErrorContainer,
        border: "none",
      },
      colorSuccess: {
        backgroundColor: mode === "dark" ? c.secondaryContainer : c.secondaryContainer,
        color: mode === "dark" ? c.onSecondaryContainer : c.onSecondaryContainer,
        border: "none",
      },
      colorWarning: {
        backgroundColor: mode === "dark" ? operational.aegis.warningChip.darkBg : operational.aegis.warningChip.lightBg,
        color: mode === "dark" ? operational.aegis.warningChip.darkFg : operational.aegis.warningChip.lightFg,
        border: "none",
      },
      outlined: {
        borderColor: `${c.outlineVariant}26`,
      },
    },
  };
}
